import baseService from '../shared/baseService';

const mediaService = () => baseService('medias');

export default {
    mediaService
};

